// extracted by mini-css-extract-plugin
export default {"modal":"modal___yxUa8Vq","logout":"logout___yxUa8Vq"};